if (!customElements.get('back-in-stock-form')) {
  class BackInStockForm extends HTMLElement {
    static COMPANY_ID = 'YwgYbZ';
    form = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();
      this.subscribeToKlaviyo(event.target);

      this.dispatchEvent(
        new CustomEvent(`${this.getAttribute('data-modal-id')}:toggle`, {
          bubbles: true,
        }),
      );
    }

    subscribeToKlaviyo(form) {
      const { email, variant_id } = form.elements;
      const backInStockURL = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${BackInStockForm.COMPANY_ID}`;

      variant_id.value = document.querySelector(
        'main-product-selector',
      )?.currentVariant.id;

      fetch(backInStockURL, {
        headers: {
          'accept': 'application/json',
          'revision': '2024-07-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email.value,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variant_id.value}`,
                },
              },
            },
          },
        }),
        method: 'POST',
      }).catch((err) => {
        console.error(err);
      });
    }
  }
  customElements.define('back-in-stock-form', BackInStockForm);
}
